import { fetchOrderById } from '@/services/orderService'

export const prepareOrderChanges = ({ getters, commit }) => {
    const changes = getters.getOrderForEdit
    commit('RESET_DIRTY_DISHES')

    if (!changes || Object.keys(changes).length === 0) {
        return {
            earlyResult: {
                message: {
                    name: 'edit',
                    variant: 'primary',
                    message: 'Заказ не сохранен, так как нет изменений.',
                },
            },
        }
    }

    if (changes.error) {
        return {
            earlyResult: {
                message: {
                    name: 'Ошибка',
                    variant: 'danger',
                    message: changes.error,
                },
            },
        }
    }

    return { changes }
}

export const fetchAndApplyOrder = async (commit, id) => {
    const updatedOrder = await fetchOrderById(id)

    if (!updatedOrder.data) {
        throw new Error('Не удалось получить данные по заказу')
    }

    commit('UPDATE_ORDER_AFTER_PUT', updatedOrder.data)

    return updatedOrder.data
}
